/**
 * Initialize endpoint mocks
 */
export const initializeMocks = () => {
  console.info('Loading endpoint mocks...')
  import('./mockEndpoints')
    .then(() => console.info('Endpoint mocks are loaded'))
    .catch((error) => {
      console.error('Failed to load endpoint mocks:', error)
    })
}
